import React, { useEffect, useState } from 'react';
import { getAdByPlacement } from '../services/api';

const AdBanner = ({ placement }) => {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    const fetchAd = async () => {
      const activeAd = await getAdByPlacement(placement);
      setAd(activeAd);
    };
    fetchAd();
  }, [placement]);

  if (!ad) return null;

  return (
    <div className={`w-full overflow-hidden text-center bg-stone-100 border border-stone-200 shadow-sm ${placement === 'sidebar' ? 'rounded-2xl max-h-[600px] sticky top-24' : 'rounded-xl max-h-[120px] mb-8'}`}>
      <span className="block text-[10px] text-stone-400 uppercase tracking-widest text-right px-2 py-0.5 border-b border-stone-200">
        Advertisement
      </span>
      <a href={ad.link} target="_blank" rel="noopener noreferrer" className="block w-full h-full relative group">
        <img 
          src={ad.image} 
          alt={ad.title} 
          className="w-full h-full object-cover transition-opacity group-hover:opacity-90"
        />
        <div className="absolute inset-0 bg-black/5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="bg-white px-3 py-1 rounded-full text-xs font-semibold text-stone-800 shadow-sm">View Offer</span>
        </div>
      </a>
    </div>
  );
};

export default AdBanner;
